import { CARE_GUIDELINES } from "../Components/Info/WashCareInstructions";

// Built-in content for the tabs on every product page (Description / Fabric
// Estimator / Shipping / Washcare). Admins can change any of it from
// Admin → HomePage → Product Page Tabs; anything not changed uses these values.
// An empty estimator image means the two bundled guides (est-1 / est-2.jpeg).
export const PRODUCT_TABS_DEFAULTS = {
  descTab: "Description",

  showEstimator: true,
  estimatorFor: "all", // "all" products, or "fabrics" (sold by the metre) only
  estimatorTab: "Fabric Estimator",
  estimatorText: "Confused about how much fabric you need? Use our estimator!",
  estimatorButton: "View Estimator",
  estimatorTitle: "Fabric Estimator",
  estimatorImage: "", // one picture for the pop-up; empty = the two original guides
  estimatorNote: "According to your measurement designs, then depends on the flare fabric estimation will vary. For further queries regarding customization, please feel free to call us at 9789389489. We are always ready to assist you. Thank you!",
  estimatorNoteBold: "9789389489",

  showShipping: true,
  shippingTab: "Shipping",
  shippingTitle: "Pan India Delivery",
  shippingText: "We ship across India with care and speed. Orders above ₹999 get free shipping.",
  shippingImage: "", // optional picture under the shipping info (none by default)

  showWashcare: true,
  washcareTab: "Washcare",
  washcareTitle: "Wash Care Instructions",
  washcareImage: "", // optional picture, e.g. a wash-symbols chart (none by default)
  washcareTips: CARE_GUIDELINES,
  washcareLink: "Read full wash care guide →",
};
